const KEY = "wado_notifications_enabled";
const URGENT_SOUND_KEY = "wado_urgent_sound";
const MUTED_KEY = "wado_muted_friends";
import api from "@/lib/api";

export function getMutedFriends() {
  try {
    return JSON.parse(localStorage.getItem(MUTED_KEY) || "[]");
  } catch {
    return [];
  }
}
export function isMuted(id) {
  return getMutedFriends().includes(id);
}
export function toggleMute(id) {
  const s = new Set(getMutedFriends());
  if (s.has(id)) s.delete(id);
  else s.add(id);
  localStorage.setItem(MUTED_KEY, JSON.stringify([...s]));
  return s.has(id);
}


// ---- Notification sounds ----
export const SOUND_PRESETS = {
  classique: { label: "Classique", notes: [[880, "sine"], [1174, "sine"]] },
  alerte: { label: "Alerte", notes: [[988, "square"], [988, "square"], [988, "square"]] },
  carillon: { label: "Carillon", notes: [[1319, "sine"], [988, "sine"], [784, "sine"]] },
  sonar: { label: "Sonar", notes: [[440, "sine"], [880, "sine"]] },
};

export function getUrgentSound() {
  return localStorage.getItem(URGENT_SOUND_KEY) || "alerte";
}
export function setUrgentSound(v) {
  localStorage.setItem(URGENT_SOUND_KEY, v);
}

export function playSound(kind = "classique") {
  try {
    const preset = SOUND_PRESETS[kind] || SOUND_PRESETS.classique;
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    if (!window.__wadoAudioCtx) window.__wadoAudioCtx = new Ctx();
    const ctx = window.__wadoAudioCtx;
    if (ctx.state === "suspended") ctx.resume();
    const now = ctx.currentTime;
    preset.notes.forEach(([freq, type], i) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = type || "sine";
      osc.frequency.value = freq;
      const start = now + i * 0.16;
      gain.gain.setValueAtTime(0.0001, start);
      gain.gain.exponentialRampToValueAtTime(0.25, start + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.15);
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start(start);
      osc.stop(start + 0.16);
    });
  } catch (e) {}
}

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
  return arr;
}

export async function subscribeToPush() {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) return false;
  try {
    const reg = await navigator.serviceWorker.ready;
    const { data } = await api.get("/push/vapid-public-key");
    if (!data.key) return false;
    let sub = await reg.pushManager.getSubscription();
    if (!sub) {
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(data.key),
      });
    }
    await api.post("/push/subscribe", sub.toJSON());
    return true;
  } catch (e) {
    return false;
  }
}

export async function unsubscribeFromPush() {
  try {
    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.getSubscription();
    if (sub) {
      await api.post("/push/unsubscribe", sub.toJSON());
      await sub.unsubscribe();
    }
  } catch (e) {}
}


export function getNotificationsEnabled() {
  return localStorage.getItem(KEY) === "true" && typeof Notification !== "undefined" && Notification.permission === "granted";
}

export function setNotificationsPref(val) {
  localStorage.setItem(KEY, val ? "true" : "false");
}

export async function requestNotificationPermission() {
  if (typeof Notification === "undefined") return "unsupported";
  if (Notification.permission === "granted") return "granted";
  try {
    return await Notification.requestPermission();
  } catch {
    return "denied";
  }
}

export function playBeep() {
  playSound("classique");
}

export function notify(title, body) {
  if (typeof Notification === "undefined" || Notification.permission !== "granted") return;
  const options = { body, icon: "/icon-192.png", badge: "/icon-192.png", tag: "wado-message" };
  if ("serviceWorker" in navigator && navigator.serviceWorker.ready) {
    navigator.serviceWorker.ready
      .then((reg) => {
        if (reg && reg.showNotification) reg.showNotification(title, options);
        else new Notification(title, options);
      })
      .catch(() => {
        try {
          new Notification(title, options);
        } catch (e) {}
      });
  } else {
    try {
      new Notification(title, options);
    } catch (e) {}
  }
}
